var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstana(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 120 135",
    style: {
      enableBackground: "new 0 0 120 135"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#00B3B3;} .st1{fill:#FFFFFF;} ")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "01_INSTANA") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52,4.6L9.6,29.1c-4.9,2.9-8,8.1-8,13.9v49c0,5.7,3.1,11,8,13.8L52,130.4c5,2.9,11,2.9,16,0l42.4-24.5 c4.9-2.9,8-8.1,8-13.8V43c0-5.7-3.1-11-8-13.8L68,4.6C63,1.8,56.9,1.8,52,4.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M73.2,80c1.7,0,3.1-1.7,3.1-3.7c0-2.1-1.4-3.7-3.1-3.7c-1.7,0-3.1,1.7-3.1,3.7C70.1,78.3,71.4,80,73.2,80z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92.2,43.5L65.7,28.2c-3.5-2-7.8-2-11.3,0L27.8,43.5c-3.5,2-5.7,5.8-5.7,9.8V84c0,4,2.2,7.8,5.7,9.8 l18.1,10.5c-1.1-2.1-1.7-4.1-1.4-6.2c0.2-1.3,1.1-3.6,3.7-5.4c0.6-0.4,1.4-0.1,1.6,0.5c0.2,0.6,0.6,1.1,1.3,1.3 c2.2,0.4,5.1,0.7,8.9,0.7c3.8,0,6.7-0.2,8.9-0.7c0.7-0.1,1.1-0.6,1.3-1.2c0.2-0.7,1-1,1.6-0.6c2.6,1.8,3.5,4.1,3.7,5.4 c0.3,2.1-0.4,4.1-1.4,6.2l18.1-10.5c3.5-2,5.7-5.8,5.7-9.8V53.4C97.9,49.3,95.7,45.6,92.2,43.5z M37.7,62.7c0-0.9,0-5.4,0-10.2 c0-1.4,0.6-2.7,1.6-3.6c4.1-3.6,10.7-7.3,20.7-7.3c10,0,16.6,3.8,20.7,7.3c1,0.9,1.6,2.2,1.6,3.5c0,4.8,0,9.3,0,10.2v11.6 c0,7-3.7,10.5-10.9,10.5H48.7c-7.3,0-10.9-3.5-10.9-10.5V62.7z M76.5,90.8c-2.7,0.5-9.3,0.6-16.5,0.6c-7.3,0-13.9-0.1-16.5-0.6 c-8.4-1.4-11.4-12-11.4-20.2c0-7.9,0.9-13.3,2.2-15.6c0.2-0.4,0.6-0.9,1.1-1.6c0,4.2,0,8.6,0,9.3v11.6c0,8.3,4.7,12.9,13.3,12.9 h22.7c8.6,0,13.3-4.6,13.3-12.9V62.7c0-0.7,0-5.1,0-9.3c0.5,0.7,0.9,1.2,1.1,1.6c1.3,2.3,2.2,7.7,2.2,15.6 C87.9,78.8,85,89.4,76.5,90.8z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st1",
    cx: 46.8,
    cy: 76.2,
    rx: 3.1,
    ry: 3.7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstana);
export default __webpack_public_path__ + "static/media/instana.213294b5ccc27857ef4937c9271a6550.svg";
export { ForwardRef as ReactComponent };